// Compartido por la marca y el lateral fijo (lg+).
export const SIDEBAR_WIDTH = 'lg:w-72';
// Padding del área de contenido: header y main consumen la misma definición.
export const CONTENT_PADDING = 'px-3 sm:px-6 lg:px-8';
// El ancho propio de Reglas no condiciona la posición del título global.
export const CONTENT_FRAME = 'mx-auto w-full max-w-7xl';
